import RoutesMap from "../../route_control/RouteControl"
import {
    BoqList,
    DatasheetList
} from "../../pages/doc"

export const DocImport = {
    RoutesMap,
    BoqList,
    DatasheetList,
}